import React from "react";
import { Icon } from "./icon";

/**
 * Portfolio tile. Self-contained Tailwind — no longer depends on the legacy
 * Bootstrap `.portfolio-item` / `.hover-bg` rules from public/css/style.css.
 */
export const Image = ({ title, category, largeImage, smallImage }) => {
  return (
    <a
      href={largeImage}
      title={title}
      target="_blank"
      rel="noopener noreferrer"
      className="group relative block overflow-hidden rounded-2xl border border-line bg-navy-950 shadow-card transition-all duration-500 ease-smooth hover:-translate-y-1.5 hover:shadow-lift"
    >
      <img
        src={smallImage}
        alt={title}
        loading="lazy"
        className="aspect-[4/3] w-full object-cover transition-all duration-700 ease-smooth group-hover:scale-[1.06]"
      />

      {/* Scrim: subtle at rest, full at hover, so titles stay legible either way */}
      <div
        className="absolute inset-0 bg-gradient-to-t from-navy-950 via-navy-950/45 to-transparent opacity-70 transition-opacity duration-500 group-hover:opacity-95"
        aria-hidden="true"
      />

      <div className="absolute inset-x-0 bottom-0 p-6">
        {category && (
          <span className="inline-block rounded-full border border-white/15 bg-white/10 px-3 py-1 text-[0.7rem] font-semibold uppercase tracking-[0.12em] text-white/85 backdrop-blur">
            {category}
          </span>
        )}

        <h3 className="mt-3 text-xl font-bold text-white">{title}</h3>

        <span className="mt-3 flex translate-y-2 items-center gap-2 text-sm font-semibold text-crimson-300 opacity-0 transition-all duration-500 ease-smooth group-hover:translate-y-0 group-hover:opacity-100">
          View project
          <Icon name="arrowUpRight" className="h-4 w-4" />
        </span>
      </div>

      {/* Corner action chip */}
      <span
        className="absolute right-5 top-5 flex h-10 w-10 -translate-y-2 items-center justify-center rounded-full bg-white/95 text-navy-900 opacity-0 shadow-lg transition-all duration-500 ease-smooth group-hover:translate-y-0 group-hover:opacity-100"
        aria-hidden="true"
      >
        <Icon name="arrowUpRight" className="h-5 w-5" />
      </span>
    </a>
  );
};
